import React, { useState, useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom';
import querystring from 'qs';
import * as profileAPI from '../../actions/profile';
import * as appDisplay from '../../actions/appDisplay';
import LoadingMessage from '../common/messages/LoadingMessage';
import PopMessage from '../common/messages/PopMessage';
import MemberSearch from '../common/member/MemberSearch';
import MemberDetails from './manage/MemberDetails';
import stateConfig from '../../config/state';
import validator from '../../utils/validator';
import config from '../../config/config';

function ManageMember({ profiles, profileAPI, appDisplay }) {
  const location = useLocation();
  const initialParams = querystring.parse(location.search.substring(1));

  const [init, setInit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [processing] = useState(false);
  const [newMember] = useState(initialParams.newMember === 'true');
  const [email, setEmail] = useState(initialParams.email || '');
  const [refresh, setRefresh] = useState(false);
  const [profile, setProfile] = useState(null);
  const [error, setError] = useState(null);
  let initialize = config.emptyFn;

  useEffect(() => {
    if(!init) {
      initialize();
      setInit(true);
    }
  }, [init, initialize]);
  
  initialize = () => {
    if(newMember) {
      appDisplay.displayPageMessage({
        message: 'Registration Complete!',
        type: stateConfig.messageTypes.SUCCESS,
        time: 5
      });
    }

    if(validator.isNotEmpty(email)) {
      setLoading(true);
      profileAPI.getMember(email);
    }
  }; 

  useEffect(() => {
    const { ids, byId } = profiles;
    const profileData = byId[`${stateConfig.keys.PROFILES}.${email}`];

    if(ids && profileData) {
      if(profileData.error) {
        setLoading(false);
        setError(profileData.error);
      } else {
        setLoading(false);
        setProfile(profileData);
      }
    }
  }, [profiles, email]);

  const onBackSelection = () => {
    setProfile(null);
    setEmail('');
    setRefresh(false);
  };

  const onSearchComplete = (profileResult) => {
    setProfile(profileResult);
    setEmail(profileResult.email);
  };

  const refreshProfile = (newEmail) => {
    const resolvedEmail = newEmail || profile.email;
    setLoading(true);
    setRefresh(true);
    setEmail(resolvedEmail);
    setProfile(null);
    profileAPI.getMember(resolvedEmail);
  };

  const clearPopMessage = () => {
    setError(null);
  };

  return (
    <div className="ManageMember">
      {loading && <LoadingMessage message='Loading...' />}
      {processing && <LoadingMessage message='Processing...' />}
      {!validator.isDefined(profile) && !refresh &&
        <MemberSearch onComplete={onSearchComplete} />
      }
      {validator.isDefined(profile) &&
        <MemberDetails profile={profile} onBack={onBackSelection} onUpdate={refreshProfile} />
      }
      {error !== null &&
        <PopMessage horizontal="center" open={true} onClose={clearPopMessage}
          type={stateConfig.messageTypes.ERROR}>
          <p>An error occurred while attempting to retrieve the requested member.</p>
        </PopMessage>
      }
    </div>
  );
}

function mapStateToProps(state) {
  return {
    profiles: state.profiles
  };
}

function mapDispatchToProps(dispatch) {
  return {
    profileAPI: bindActionCreators(profileAPI, dispatch),
    appDisplay: bindActionCreators(appDisplay, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ManageMember);